module.exports = __webpack_public_path__ + "img/icon_home_kefu@2x.269b59dd.png";